<nb-card>
  <nb-card-header
    >Chia sẻ
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <input
          type="text"
          nbInput
          fullWidth
          disabled
          shape="semi-round"
          class="form-control"
          [(ngModel)]="link"
        />
        <button
          nbSuffix
          nbButton
          ghost
          shape="semi-round"
          nbTooltip="Sao chép liên kết"
          (click)="copyLink()"
        >
          <nb-icon icon="copy-outline"> </nb-icon>
        </button>
      </nb-form-field>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <nb-actions size="none">
      <nb-action (click)="openLink()">
        <nb-icon
          [status]="'info'"
          class="action-icon"
          icon="external-link-outline"
        ></nb-icon>
        Xem thử
      </nb-action>

      <nb-action (click)="copyLink()">
        <nb-icon
          [status]="'info'"
          class="action-icon"
          icon="copy-outline"
        ></nb-icon>
        Sao chép liên kết
      </nb-action>
    </nb-actions>
  </nb-card-footer>
</nb-card>
